import Axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import ReactTooltip from 'react-tooltip';
import { API_HOST, axiosInstance, axiosRequestWithAuth } from '../../../constants/server.constant';
import FlavorService from '../../../services/flavor.service';
import { formatBandwidthBytes, formatBytes } from '../../../utility/utility';
import $ from 'jquery';

const InstanceBilling = (props) => {

    const [isPrepaidYearly, setIsPrepaidYearly] = useState(false);
    const [isPrepaidMonthly, setIsPrepaidMonthly] = useState(false);
    const [isPostpaidMonthly, setIsPostpaidMonthly] = useState(false);
    const [serverStartDate, setServerStartDate] = useState();
    const [serverStatus, setServerStatus] = useState();
    const [serverEndDate, setServerEndDate] = useState();
    const [roleId, setRoleId] = useState(localStorage.getItem("roleId"));
    const [flavour, setFlavour] = useState({
        ram: 0,
        vcpus: 0,
        disk: 0,
        bandwidth: 0,
        cpuType: ""
    });
    const [isOpenPopup, setIsOpenPopup] = useState(false);
    const [userId, setUserId] = useState(localStorage.getItem("userId"));
    const [insQuota, setInsQuota] = useState({ usedQuota: 0, totalQuota: 1 });
    const [showBandwidth, setShowBandwidth] = useState(true);
    const [showButton, setShowButton] = useState(false);
    const [billingDate, setBillingDate] = useState();
    const [isCancelPopUp, setIsCancelPopUp] = useState(false);

    useEffect(() => {
        if(roleId === "1" || props.instance.metadata?.opType === 'migration') {
            props.history.push("/error");
        }
        props.bgShadowHandler(true);
        checkServerExists();
        return (() => {
            props.msgHandler("");
        });
    }, []);
    useEffect(() => {
        const handleEsc = (event) => {
            if(event.keyCode === 27) {
                setIsOpenPopup(false);
                setIsCancelPopUp(false);
                $("body").removeClass("popup_no_scroll");
            }
        };
        window.addEventListener('keydown', handleEsc, false);

        return () => {
            window.removeEventListener('keydown', handleEsc, false);
            $("body").removeClass("popup_no_scroll");

        };
    }, [setIsOpenPopup]);

    const checkServerExists = () => {
        FlavorService.getServerExists(props.instance.id).then(resp => {

            if(resp === false) {
                props.bgShadowHandler(false);
                props.msgHandler("Error while getting server details");
            }
            if(!resp.error) {
                if(resp.paymentType === "Y") {
                    setIsPrepaidYearly(true);
                    if(resp.serverStatus === 1) {
                        setShowButton(true);
                    }
                    setServerStatus(resp.serverStatus);

                    let startDate = new Date(resp.serverCreationDate);
                    let endDate = new Date(resp.serverEndDate);

                    let insStartDate = startDate.toLocaleString('default', { month: 'short' }) + ' ' + startDate.getDate() + ', ' + startDate.getFullYear() + ' ' + startDate.toLocaleString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                    });
                    let insEndDate = endDate.toLocaleString('default', { month: 'short' }) + ' ' + endDate.getDate() + ', ' + endDate.getFullYear();
                    let billingDate = new Date(resp.serverEndDate);
                    billingDate.setMonth(billingDate.getMonth() + 1);
                    billingDate.setDate(1);
                    let billingFormat = billingDate.toLocaleString('default', { month: 'short' }) + ' ' + billingDate.getDate() + ', ' + billingDate.getFullYear();
                    setServerStartDate(insStartDate);
                    setServerEndDate(insEndDate);
                    setBillingDate(billingFormat);
                }
                if(resp.paymentType === "M") {
                    setIsPrepaidMonthly(true);
                    setShowButton(false);
                    setServerStatus(resp.serverStatus);
                    let startDate = new Date(resp.serverCreationDate);
                    let endDate = new Date(resp.serverEndDate);
                    let insStartDate = startDate.toLocaleString('default', { month: 'short' }) + ' ' + startDate.getDate() + ', ' + startDate.getFullYear() + ' ' + startDate.toLocaleString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                    });
                    let insEndDate = endDate.toLocaleString('default', { month: 'short' }) + ' ' + endDate.getDate() + ', ' + endDate.getFullYear();

                    setServerStartDate(insStartDate);
                    setServerEndDate(insEndDate);

                }

            }
            else {
                setIsPostpaidMonthly(true);
                setServerStatus(0);
                let date = new Date();
                if(date.getMonth() == 11) {
                    var current = new Date(date.getFullYear() + 1, 0, 1);
                    setServerEndDate(formateDate(current));
                } else {
                    var current = new Date(date.getFullYear(), date.getMonth() + 1, 1);
                    setServerEndDate(formateDate(current));

                }

            }
            getFlavourDetails();

        }).catch(error => {
            props.bgShadowHandler(false);
            props.msgHandler("Error while getting server details");
        });
    };
    const formateDate = (endDate) => {

        return endDate.toLocaleString('default', { month: 'short' }) + ' ' + endDate.getDate() + ', ' + endDate.getFullYear();;
    };

    const getFlavourDetails = () => {
        let flavoursQuota = "";
        axiosInstance.get(API_HOST + "/flavors/getflavour/" + props.instance.flavor.id + "/" + userId, axiosRequestWithAuth)
            .then(resp => {

                resp = resp.data;
                flavoursQuota = resp;
                setFlavour(resp);
                getInstanceQuotaDetails(flavoursQuota);


            })
            .catch(error => {
                props.bgShadowHandler(false);
                props.msgHandler("Error while getting flavour details");
            });

    };

    const getInstanceQuotaDetails = (flavoursQuota) => {
        axiosInstance.get(API_HOST + "/resource/getquota/" + userId + "?instanceId=" + props.instance.id, axiosRequestWithAuth)
            .then(resp => {
                props.bgShadowHandler(false);
                if(resp.data != null && resp.data != "") {
                    setInsQuota(resp.data);
                }
                else {

                    let date = new Date(props.instance.createdOn);
                    let current = new Date();
                    let proRated = "";
                    if(date.getMonth() === current.getMonth() && date.getFullYear() === current.getFullYear()) {
                        let bandwidth = flavoursQuota.bandwidth;
                        let dayBandWidth = bandwidth / 30;
                        let getDate = 30 - date.getDate();
                        if(getDate === -1) {
                            proRated = bandwidth;
                        }
                        else {
                            proRated = getDate * dayBandWidth;
                        }
                    }
                    else {
                        proRated = flavoursQuota.bandwidth;
                    }
                    let obj = {
                        usedQuota: 0,
                        totalQuota: proRated
                    };
                    setInsQuota(obj);
                }

            })
            .catch(error => {
                props.bgShadowHandler(false);
                props.msgHandler("Error while getting quota details");
            });
    };

    const openConfrimationPopup = (e, param) => {
        if(param === "convert") {
            setIsOpenPopup(true);
            setIsCancelPopUp(false);
        }
        else {
            setIsOpenPopup(false);
            setIsCancelPopUp(true);
        }
        $("body").addClass("popup_no_scroll");

    };

    const closeMessage = () => {
        setTimeout(() => {
            props.msgHandler("");
        }, 10000);
    };

    const convertPlan = (e, param) => {
        props.bgShadowHandler(true);
        setIsOpenPopup(false);
        setIsCancelPopUp(false);
        let status = 2;
        if(param === "set1") {
            status = 1;
        }
        Axios.post(API_HOST + "/resource/changeplan/" + userId + "?instanceId=" + props.instance.id + "&insName=" + props.instance.name + "&bilDate=" + billingDate + "&status=" + status, {}, axiosRequestWithAuth)
            .then(resp => {
                resp = resp.data;
                if(resp.hasOwnProperty("error") && !resp.error) {
                    props.msgHandler("Plan has been updated successfully");
                    closeMessage();
                    setServerStatus(2);
                    setShowButton(false);
                    checkServerExists();
                }
                $("body").removeClass("popup_no_scroll");
            }).catch(error => {
                props.bgShadowHandler(false);
                $("body").removeClass("popup_no_scroll");
            });
    };

    return (
        <section className="settingModule_wrapper changePlan_setting_module">
            <div className="settModule_head_wrap">
                <div className="settModule_head_lhs">
                    <h2>Instance Billing Details</h2>
                    <p className="head_info">View the bandwidth usage and billing details for the instance</p>
                </div>
            </div>
            <div className="instancePlan_wrpr">
                <p className="planName">Plan Name:<span>{ isPrepaidYearly ? "Prepaid Yearly" : isPrepaidMonthly ? "Prepaid Monthly" : "Postpaid Monthly" }</span></p>
                <div className="plan_box ">
                    <div className="cost_details" style={ { display: "none" } }>
                        <div className="cost_option2 actual_cost"><span className="strike_thru">$60</span><span className="cost-sub">/year</span></div>
                        <div className="cost_option1">$30<span className="cost-sub">/first year</span></div>
                    </div>
                    <div className="plan_details">
                        <ul className="detail_info">
                            <li>
                                <div className="col1">CPU Type</div>
                                <div className="col2">{ flavour.type === "SCPU" ? "Shared CPU" : "Dedicated CPU" }</div>
                            </li>
                            <li>
                                <div className="col1">RAM</div>
                                <div className="col2">{ flavour.ram / 1024 + ' GB' }</div>
                            </li>

                            <li>
                                <div className="col1">Processor</div>
                                <div className="col2">{ Number(flavour.vcpus) <= 1 ? flavour.vcpus + " CPU" : flavour.vcpus + " CPUs" }</div>
                            </li>
                            <li>
                                <div className="col1">NVMe Storage</div>
                                <div className="col2">{ flavour.disk } GB</div>
                            </li>
                            <li>
                                <div className="col1">Bandwidth</div>
                                <div className="col2">{ formatBandwidthBytes(flavour.bandwidth) }</div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="bandwidth_blk" style={ { display: showBandwidth ? "" : "none" } }>
                    <h4>Bandwidth Usage</h4>
                    <div className="bandwidth_progress">
                        <div className="boot_container">
                            <div className="boot_wrapper">
                                <div className="progress_wrap">
                                    <span className="progress_limit">{ formatBandwidthBytes(insQuota.usedQuota) } of { formatBandwidthBytes(insQuota.totalQuota) } used</span>
                                    <span className="progress_val">{ Math.round((insQuota.usedQuota / insQuota.totalQuota) * 100) }%</span>
                                    <div className="progress_bar">
                                        <span className="percent_progress" style={ { width: Math.round((insQuota.usedQuota / insQuota.totalQuota) * 100) + '%' } }></span>
                                    </div>
                                </div>
                                {/* <span className="svg_wrap">
                                    <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                        <path fillRule="evenodd" clipRule="evenodd" fill="#669ebe" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                        <text transform="matrix(1 0 0 1 9.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="14px">i</text>
                                    </svg>
                                </span> */}
                            </div>
                        </div>
                        <div className="usage_details">
                            <p>Bandwidth overage usage charges:<br></br><strong>$0.01/GB</strong> over the allocated monthly quota</p>
                        </div>
                    </div>
                </div>
                <div className="btn_blk">
                    <button className="common_cta_btn blue showConfirmpopup" type="button" name="" value="" onClick={ (e) => openConfrimationPopup(e, "convert") } style={ { display: showButton ? "" : "none" } } >Switch to Postpaid Monthly Plan</button>
                </div>
                <p className="offer_note notePmonthly" style={ { display: showButton ? "" : "none" } }><strong>Note: </strong>On switching the billing plan, the pending payments for the current plan will be admissible to the new monthly plan. Your next billing date will be <strong>{ serverEndDate }</strong>.</p>
                <p className="offer_note notePmonthly" style={ { display: !showButton && serverStatus !== 2 ? "" : "none" } }><strong>Note: </strong>Your next billing date will be <strong>{ serverEndDate }</strong>.</p>
                <div className="plansuccessBlk" style={ { display: serverStatus === 2 ? "" : "none" } }>
                    <div className="plansuccessMsg">
                        <p>Your subscription has been changed to Postpaid Monthly Plan </p>
                        <span><strong>Plan: </strong>{ flavour.type === "SCPU" ? "Shared CPU" : "Dedicated CPU" }, { Number(flavour.vcpus) <= 1 ? flavour.vcpus + " CPU" : flavour.vcpus + " CPUS" }, { flavour.disk }GB NVMe Storage,{ flavour.ram / 1024 + ' GB' } RAM, { formatBandwidthBytes(flavour.bandwidth) } Bandwidth</span><br></br>
                        <span>The plan will be applicable from <strong>{ serverEndDate }</strong></span>
                    </div>
                    <p ><a href="#" className="cancelSubscribe" onClick={ (e) => { e.preventDefault(); openConfrimationPopup(e, "cancel"); } }>Switch Back to Prepaid Yearly Plan</a></p>
                </div>
            </div>
            <div className={ isOpenPopup ? "main_popup changePlan_conf_popup active" : "main_popup changePlan_conf_popup" } >
                <div className="main_popup_wrapper">
                    <div className="main_popup_bg_shadow"></div>
                    <div className="main_popup__inner">
                        <div className="popup_wrap">
                            <span className="close_icon" data-for='close' data-tip onClick={ () => { setIsOpenPopup(false); $("body").removeClass("popup_no_scroll"); } }></span>
                            <ReactTooltip id="close" effect='solid' place='top'>Close</ReactTooltip>
                            <div className="popup_header">
                                <div className="sub_title">Switch to Postpaid Monthly Plan</div>
                            </div>
                            <div className="resize_popup_body">
                                <div className="popup_body">
                                    <p>This will change your Prepaid Yearly subscription to Postpaid Monthly subscription.<br></br>
                                        <span><strong>Plan: </strong>{ flavour.type === "SCPU" ? "Shared CPU" : "Dedicated CPU" }, { Number(flavour.vcpus) <= 1 ? flavour.vcpus + " CPU" : flavour.vcpus + " CPUS" }, { flavour.disk } GB NVMe Storage, { flavour.ram / 1024 + ' GB' } RAM, { formatBandwidthBytes(flavour.bandwidth) } Bandwidth</span></p>
                                    <p>Do you want to proceed?</p>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <button value="" className="btn blue showplanSuccess" onClick={ (e) => convertPlan(e, "set2") }>Yes</button>
                                        <button className="btn btn_cancel" onClick={ () => { setIsOpenPopup(false); $("body").removeClass("popup_no_scroll"); } }>No</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={ isCancelPopUp ? "main_popup planConfirmation_pup active" : "main_popup planConfirmation_pup" }>
                <div className="main_popup_wrapper">
                    <div className="main_popup_bg_shadow"></div>
                    <div className="main_popup__inner">
                        <div className="popup_wrap">
                            <span className="close_icon" data-for='close' data-tip onClick={ () => { setIsCancelPopUp(false); $("body").removeClass("popup_no_scroll"); } }></span>
                            <ReactTooltip id="close" effect='solid' place='top'>Close</ReactTooltip>
                            <div className="popup_header">
                                <div className="sub_title">Cancel Your Postpaid Monthly Subscription</div>
                            </div>
                            <div className="popup_body">
                                <p>This will change your subscription to Yearly Plan.</p>
                                <p>Do you want to proceed?</p>
                            </div>
                            <div className="popup_footer">
                                <div className="popup_footer__btns">
                                    <div className="btn btn_confirm" onClick={ (e) => convertPlan(e, "set1") }>Yes</div>
                                    <div className="btn btn_cancel" onClick={ () => { setIsCancelPopUp(false); $("body").removeClass("popup_no_scroll"); } }>No</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    );
};

export default InstanceBilling;